import React from "react";
import { Link } from "react-router-dom";
import { SidebarSkeleton } from "../../components";
import { ApiHelper, PlaylistInterface, ToastHelper } from "../../helpers";


interface Props {
  refreshKey: string
}


export const PlaylistsSidebar: React.FC<Props> = props => {

  const [playlists, setPlaylists] = React.useState<PlaylistInterface[]>(null);
  const [selectedPlaylist, setSelectedPlaylist] = React.useState<PlaylistInterface>(null);

  const init = () => {
    ApiHelper.get<PlaylistInterface[]>("/playlists")
      .then((data) => setPlaylists(data || []))
      .catch(err => {
        console.error("Failed to load playlists:", err);
        ToastHelper.error("Failed to load playlists");
      });
  }

  const updateSelected = () => {
    let result: PlaylistInterface = null;
    const parts = window.location.href.split("?")[0].split("/");
    const id = parseInt(parts[parts.length - 1]);
    playlists?.forEach(p => { if (p.id === id) result = p; })
    setSelectedPlaylist(result);
  }

  React.useEffect(init, [props.refreshKey])
  React.useEffect(updateSelected, [playlists, window.location.href]) //eslint-disable-line

  const getPlaylists = (playlistType:string) => {
    if (playlists === null) return <SidebarSkeleton count={3} />
    else {
      const result: React.ReactElement[] = [];

      const filtered = (playlistType==="feed") 
        ? playlists.filter(p => p.subscriptionId > 0)
        : playlists.filter(p => !(p.subscriptionId > 0));

      filtered?.forEach(p => {
        let className = (p.id === selectedPlaylist?.id) ? "active" : "";
        result.push(<li key={"p" + p.id} className="nav-item"><Link className={className} to={"/playlists/" + p.id}>{p.name || "(No name)"}</Link></li>);
      });
      return result;
    }
  }

  return (
    <>
      <div className="titlebar">
        <div className="float-right">
          <Link to={"/playlists?mode=feed"} className="btn btn-sm btn-success">
            <i className="fas fa-plus"></i> New
          </Link>
        </div>
        <div className="title"><i className="fas fa-list-ul"></i> Feeds</div>
      </div>
      <ul className={(playlists?.length > 15) ? "nav flex-column condensed" : "nav flex-column"}>
        {getPlaylists("feed")}
      </ul>

      <div className="titlebar">
        <div className="float-right">
          <Link to={"/playlists?mode=custom"} className="btn btn-sm btn-success">
            <i className="fas fa-plus"></i> New
          </Link>
        </div>
        <div className="title"><i className="fas fa-list-ul"></i> Custom</div>
      </div>
      <ul className={(playlists?.length > 15) ? "nav flex-column condensed" : "nav flex-column"}>
        {getPlaylists("custom")}
      </ul>
    </>
  );
};